export enum ServiceCardItem {
    Energy = 'energy',
    BoilerMaintenance = 'boiler-maintenance',
    Telecom = 'telecom',
    TelecomTransfer = 'telecom-transfer',
}
